import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

export interface Chain {
  id: string;
  chainType: number;
  chainId: string;
  chainCode: string;
  nativeAssetName: string;
  displayName: string;
  createdDate: Date;
  lastModifiedDate: Date;
  chainName: string;
}

interface InitState {
  list: Chain[];
}

const initialState: InitState = { list: [] };

export const chainsSlice = createSlice({
  name: 'chainsSlice',
  initialState,
  reducers: {
    setChainsList: (state, action) => {
      state.list = action.payload;
    },
  },
});

export const { setChainsList } = chainsSlice.actions;

export const selectChainList = (state: RootState) => state.chains;

export default chainsSlice.reducer;
